export const QUARANTINE_UNLOAD = 'QUARANTINE_UNLOAD'

export const unload = (companyKey) => ({
  type: QUARANTINE_UNLOAD,
  companyKey
})
